import React from 'react';
import styles from './Logo.module.css';

const Logo: React.FC = () => {
  return (
    <div className={styles.logo}>
      <div className={styles.logoContainer}>
        {/* Koin image */}
        <img src="/images/koin.svg" alt="Koin" className={styles.koinImg} />
        
        {/* X image next to koin */}
        <img src="/images/X.svg" alt="X" className={styles.xImg} />
        
        {/* Registered symbol slightly above */}
        <img src="/images/registered®.svg" alt="Registered" className={styles.registeredImg} />
        
        {/* Blue dots in appropriate positions */}
        <img src="/images/blue-dot-1.svg" alt="" className={styles.blueDot1} />
        <img src="/images/blue-dot-2.svg" alt="" className={styles.blueDot2} />
      </div>
    </div>
  );
};

export default Logo;